var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleIcon = function SvgPeopleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7498 2.5C11.6788 2.5 9.99984 4.17893 9.99984 6.25C9.99984 8.32107 11.6788 10 13.7498 10C15.8209 10 17.4998 8.32107 17.4998 6.25C17.4998 4.17893 15.8209 2.5 13.7498 2.5ZM11.6665 6.25C11.6665 5.09941 12.5992 4.16667 13.7498 4.16667C14.9004 4.16667 15.8332 5.09941 15.8332 6.25C15.8332 7.40059 14.9004 8.33333 13.7498 8.33333C12.5992 8.33333 11.6665 7.40059 11.6665 6.25Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 10.8333C10.0748 10.8333 7.9165 13.7786 7.9165 16.6667H9.58317C9.58317 14.5547 11.1333 12.5 13.7499 12.5C16.3664 12.5 17.9165 14.5547 17.9165 16.6667H19.5832C19.5832 13.7787 17.425 10.8333 13.7499 10.8333Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.416504 17.5C0.416504 14.684 2.35722 11.6667 5.83323 11.6667C6.66396 11.6667 7.42413 11.8445 8.09646 12.164L7.38108 13.6693C6.93659 13.4581 6.42129 13.3333 5.83323 13.3333C3.54191 13.3333 2.08317 15.316 2.08317 17.5H0.416504Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83317 4.16667C3.99222 4.16667 2.49984 5.65905 2.49984 7.5C2.49984 9.34095 3.99222 10.8333 5.83317 10.8333C7.67412 10.8333 9.1665 9.34095 9.1665 7.5C9.1665 5.65905 7.67412 4.16667 5.83317 4.16667ZM4.1665 7.5C4.1665 6.57953 4.9127 5.83333 5.83317 5.83333C6.75365 5.83333 7.49984 6.57953 7.49984 7.5C7.49984 8.42047 6.75365 9.16667 5.83317 9.16667C4.9127 9.16667 4.1665 8.42047 4.1665 7.5Z",
    fill: "#BBBBBB"
  })));
};
export { SvgPeopleIcon as ReactComponent };
export default __webpack_public_path__ + "assets/f2318215.svg";